import { endOfMonth, endOfYear, format, isValid, startOfMonth, startOfYear, subDays, subMonths, subYears } from 'date-fns';

import getTimeSince from './getTimeSince';
import subHours from 'date-fns/subHours';

export const timeSinceFormat = (date, format) => {
  return getTimeSince(formatDate(date, format));
};

export const properDate = (dateString = '') => {
  if (/\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/.test(dateString)) {
    return dateString;
  }
  return (dateString || '').replace(/ /g, 'T') + '+00:00';
};

export const formatDate = (date = '', date_fns_format = 'MM/dd/yyyy h:mm a') => {
  if (!date) {
    return 'Date not found';
  }
  if (!date_fns_format) {
    throw new Error(`Please provide a format to formatDate utility function ->>> https://date-fns.org/v2.17.0/docs/format`);
  }

  date = properDate(date);

  if (isValid(new Date(date)) && date !== null && date !== '-1') {
    return format(new Date(date), date_fns_format);
  } else {
    return 'Incorrect date format';
  }
};

export const adjustDateTimezone = (dateString) => {
  const dateObject = new Date(properDate(dateString));
  const hoursOffset = new Date().getTimezoneOffset() / 60;
  return subHours(dateObject, hoursOffset);
};

export const PRESET_DATES_HELPERS = {
  startOfMonthThirteenMonthsAgo: startOfMonth(subMonths(new Date(), 13)),

  startOfMonthSixMonthsAgo: startOfMonth(subMonths(new Date(), 6)),
  endOfMonthSixMonthsAgo: endOfMonth(subMonths(new Date(), 6)),

  startOfMonthSixMonthsAgoLastYearEquivalent: subYears(startOfMonth(subMonths(new Date(), 6)), 1),
  endOfMonthSixMonthsAgoLastYearEquivalent: subYears(endOfMonth(subMonths(new Date(), 6)), 1),

  startOfMonthOneYearAgo: startOfMonth(subYears(new Date(), 1)),

  startOfMonthTwelveMonthsAgo: startOfMonth(subMonths(new Date(), 12)),
  endOfMonthTwelveMonthsAgo: endOfMonth(subMonths(new Date(), 12)),

  startOfLastYear: startOfYear(subMonths(new Date(), 12)),
  endOfLastYear: endOfYear(subMonths(new Date(), 12)),

  startOfYearBeforeLast: startOfYear(subYears(new Date(), 2)),
  endOfYearBeforeLast: endOfYear(subYears(new Date(), 2)),

  startOfThisYear: startOfYear(new Date()),
  endOfThisYear: endOfYear(new Date()),

  startOfThisMonth: startOfMonth(new Date()),
  endOfThisMonth: endOfMonth(new Date()),

  startOfMonthThreeMonthsAgo: startOfMonth(subMonths(new Date(), 3)),
  startOfMonthTwoMonthsAgo: startOfMonth(subMonths(new Date(), 2)),

  startOfLastMonth: startOfMonth(subMonths(new Date(), 1)),
  endOfLastMonth: endOfMonth(subMonths(new Date(), 1)),

  startOfMonthBeforeLast: startOfMonth(subMonths(new Date(), 2)),
  endOfMonthBeforeLast: endOfMonth(subMonths(new Date(), 2)),

  ninetyDaysAgo: subDays(new Date(), 90),
};

export const GET_START_OF_YEAR_FROM_DATE = (dateState) => {
  const startDate = format(startOfYear(new Date(dateState.startDate)), 'yyyy-MM-dd');
  const endDate = format(endOfMonth(new Date(dateState.endDate)), 'yyyy-MM-dd');
  return { ...dateState, startDate, endDate };
};
